import script from "./ColectionEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./ColectionEntry.vue?vue&type=script&setup=true&lang=js"

import "./ColectionEntry.vue?vue&type=style&index=0&id=650d804d&lang=css"

const __exports__ = script;

export default __exports__